import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Suspense } from "react";
import Mainlayout from "./layouts/Mainlayout";
import { useAuth } from "./routes/Auth";
import AppRoutes from "./routes/AppRoutes";

function App() {
  const { isSignedIn, UserDetails } = useAuth();
  const routes = AppRoutes();

  const renderRoutes = (routes) => {
    return routes.map(
      ({ path, element, isPrivate, children, roles, index }) => {
        let finalElement = element;

        // 🔐 Auth check
        if (isPrivate && !isSignedIn) {
          finalElement = <Navigate to="/" replace />;
        }

        // 🔐 Role check
        if (isPrivate && roles && !roles.includes(UserDetails?.role)) {
          finalElement = <Navigate to="/unauthorized" replace />;
        }

        return (
          <Route
            key={path || "index"}
            path={path}
            element={finalElement}
            index={index}
          >
            {children && renderRoutes(children)}
          </Route>
        );
      }
    );
  };


  return (
    <Router>
      <Mainlayout>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {renderRoutes(routes)}
          </Routes>
        </Suspense>
      </Mainlayout>
    </Router>
  );
}

export default App;